import { render, staticRenderFns } from "./LeveledGames.vue?vue&type=template&id=4ebc6b4e&scoped=true&"
import script from "./LeveledGames.vue?vue&type=script&lang=js&"
export * from "./LeveledGames.vue?vue&type=script&lang=js&"
import style0 from "./LeveledGames.vue?vue&type=style&index=0&id=4ebc6b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebc6b4e",
  null
  
)

export default component.exports